"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = reducer;
exports.selectInterval = exports.selectPlan = exports.SELECT_INTERVAL = exports.SELECT_PLAN = void 0;

var _ = require(".");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  data: {}
};
var SELECT_PLAN = new _.Action('SELECT_PLAN');
exports.SELECT_PLAN = SELECT_PLAN;
var SELECT_INTERVAL = new _.Action('SELECT_INTERVAL');
exports.SELECT_INTERVAL = SELECT_INTERVAL;

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SELECT_PLAN.main:
      return {
        data: _objectSpread(_objectSpread({}, state.data), {}, {
          selectedPlan: action.payload.plan
        })
      };

    case SELECT_INTERVAL.main:
      return {
        data: _objectSpread(_objectSpread({}, state.data), {}, {
          selectedInterval: action.payload.interval
        })
      };

    default:
      return state;
  }
}

var selectPlan = function selectPlan(plan) {
  return {
    type: SELECT_PLAN.main,
    payload: {
      plan: plan
    }
  };
};

exports.selectPlan = selectPlan;

var selectInterval = function selectInterval(interval) {
  return {
    type: SELECT_INTERVAL.main,
    payload: {
      interval: interval
    }
  };
};

exports.selectInterval = selectInterval;